export const getAvailability = ({ sku, vendorId, originalId }) => ({
  type: 'FETCH_RECOMENDATION_CARD_AVAILABILITY',
  sku,
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'get',
      url: `/v1/products/skus/${sku}/availability`,
      params: {
        vendorId,
        originalId
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/features/Availability/ProductRecomendationCard/actions.js